module.exports = __webpack_public_path__ + "img/f4d64ad.jpg";